export default __webpack_public_path__ + "static/media/img54.fd899af8.jpg";